<template>
  <div class="flex w-full h-full mx-auto p-6">
    <div class="bg-white shadow-lg rounded-lg w-2/6 mx-4 pt-4 pb-48 px-4 overflow-hidden">
      <div class="flex items-center pb-4">
        <h3
          class="flex items-center font-bold text-gray-900 px-2 py-2 leading-tight tracking-wider"
        >
          Lista de lugares
          <span
            class="rounded-full ml-2 border-solid border-2 border-gray-300 px-3 py-1 bg-gray-100"
          >{{filteredPlaces.length}}</span>
        </h3>
        <button class="border-2 rounded border-gray-700" @click="changeFormOrder">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 fill-current" viewBox="0 0 24 24">
            <path d="M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z" />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </button>
        <div
          class="rounded-full cursor-pointer bg-primary-color hover:bg-primary-color-dark p-1 ml-2"
          @click="openAddModal()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="fill-current text-white h-6 w-6"
            viewBox="0 0 24 24"
          >
            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <input
        type="text"
        v-model="search"
        placeholder="Búsqueda de lugares"
        class="w-full appearance-none border rounded py-2 px-3 mb-3 text-gray-900 bg-gray-200 focus:outline-none focus:bg-white focus:border-teal-500"
      />
      <div class="w-full">
        <div class="w-full relative mb-2">
          <select
            class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            name="status"
            id="status"
            v-model="categoryFilter"
          >
            <option selected value="-1">Todos</option>
            <template v-for="category in placeCategories">
              <option :key="category.id" :value="category.id">{{category.nombre_categoria}}</option>
            </template>
          </select>
          <div
            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
          >
            <svg
              class="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
      </div>
      <!-- <div class="w-full flex pt-4 pb-2">
        <button
          class="w-1/3 hover:bg-blue-500 font-semibold hover:text-white py-2 px-4 border-t border-l border-b border-blue-500 hover:border-transparent rounded"
        >Todos</button>
        <button
          class="w-1/3 hover:bg-blue-500 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded"
        >Activos</button>
        <button
          class="w-1/3 hover:bg-blue-500 font-semibold hover:text-white py-2 px-4 border-t border-r border-b border-blue-500 hover:border-transparent rounded"
        >Inactivos</button>
      </div>-->
      <div class="h-full overflow-auto">
        <div
          v-for="place in filteredPlaces"
          :key="place.id"
          class="group flex items-center cursor-pointer my-1 hover:bg-gray-300 py-2 px-5 text-left"
          :class="{'bg-secondary-color': place.id === currentPlace.id}"
          @click="selectPlace(place)"
        >
          <div class="flex w-1/6">
            <img
              v-if="place.icon !== 'null'"
              :src="srcUrl+'/img/places_icons/'+place.icon"
              class="h-12 w-12"
            />
            <img v-else :src="srcUrl + '/' + place.url_image" />
          </div>
          <div class="flex w-5/6 flex-col ml-2">
            <span
              :class="[place.id === currentPlace.id ? 'text-gray-100' : 'text-gray-900']"
              class="group-hover:text-gray-900"
            >{{ place.nombre }}</span>
            <span
              :class="[place.id === currentPlace.id ? 'text-gray-300' : 'text-gray-700']"
              class="text-sm group-hover:text-gray-700"
            >{{ place.nombre_categoria }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-wrap bg-white shadow-lg rounded-lg w-4/6 mx-4 py-8 overflow-hidden">
      <div class="w-full px-4 py-2 h-full overflow-auto">
        <div class="w-full">
          <div class="w-full pb-2 text-right">
            <button
              v-if="placeComments.length > 0"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 border border-secondary-color-dark hover:border-transparent rounded"
              @click="showCommentsModal = true"
            >Ver comentarios</button>
            <button
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 border border-secondary-color-dark hover:border-transparent rounded"
              @click="openEditModal()"
            >Editar</button>
            <button
              class="bg-transparent hover:bg-red-500 text-danger-color font-semibold hover:text-white py-2 px-4 mx-1 border border-danger-color hover:border-transparent rounded"
              @click="showingConfirm = true"
            >Eliminar</button>
          </div>
          <div class="flex">
            <div class="h-80 w-full">
              <l-map
                ref="map"
                class="h-full w-full z-0"
                :zoom="zoom"
                :minZoom="11"
                :center="center"
                :options="{zoomControl: false}"
                @ready="onMapReady"
              >
                <l-geo-json :geojson="polygon" :options-style="geoStyle" />
                <l-marker :lat-lng="center" :visible="showMarker"></l-marker>
              </l-map>
            </div>
          </div>
          <div class="flex py-2">
            <div class="w-full px-4 text-left">
             <div class="font-bold tracking-wide text-lg text-gray-900">{{ currentPlace.nombre }}</div>
              <div
                class="text-sm text-gray-700"
                v-html="removeLineBreaks(this.currentPlace.descripcion)"
              ></div>
              <p
                v-if="currentPlace.costo !== '' && currentPlace.costo !== null"
                class="text-base text-gray-700 pt-2"
              >
                <span class="font-bold">Costo: </span>
                <span class="text-sm">{{ currentPlace.costo }}</span> 
              </p>
              <p class="font-bold text-base text-gray-700">Horario:</p>
              <div v-for="(day, index) in workingHours" :key="index">
                <div class="flex w-1/3 text-sm" v-if="day.label !== 'enable' && day.open !== ''">
                  <span class="w-2/5 tracking-wide">{{day.label}}:</span>
                  <span class="w-3/5">{{day.open}} &ndash; {{day.close}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <place-modal
      :showing="showPlaceModal"
      :place="modalPlace"
      :aux_place="aux_modalPlace"
      :modalAction="modalAction"
      @close="closeModal"
      @updateData="updateData"
    ></place-modal>
    <alert-dialog :showing="showingSuccess">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Lugar de interés guardado exitosamente</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccess = false"
        >Cerrar</button>
      </div>
    </alert-dialog>
    <alert-dialog :showing="showingConfirm">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">¿Desea eliminar el lugar de interés?</div>
      </div>
      <div class="w-full flex items-center justify-center">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-red-500 border-4 font-bold tracking-wider bg-white hover:bg-red-300"
          @click="deletePlace()"
        >Eliminar</button>
        <button
          class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingConfirm = false"
        >Cerrar</button>
      </div>
    </alert-dialog>
    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Ha ocurrido un error</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-danger-color"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >Cerrar</button>
      </div>
    </alert-dialog>
    <alert-dialog :showing="showingSuccessDelete">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Lugar de interés eliminado exitosamente</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-primary-color"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccessDelete = false"
        >Cerrar</button>
      </div>
    </alert-dialog>
    <place-comments-modal
      :showing="showCommentsModal"
      @close="closeCommentsModal"
      :placeComments="placeComments"
      @updateComments="updateComments"
    ></place-comments-modal>
  </div>
</template>

<script>
import PlaceModal from "./PlaceModal";
import AlertDialog from "./AlertDialog";
import PlaceCommentsModal from "./PlaceCommentsModal";
import polygon from "../assets/polygonChapp.json";

import L from "leaflet";
import { LMap, LMarker, LGeoJson } from "vue2-leaflet";
import * as esri from "esri-leaflet";

import { Icon } from "leaflet";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

export default {
  name: "places-list",
  data() {
    return {
      places: [],
      search: "",
      currentPlace: {},
      showPlaceModal: false,
      showingSuccess: false,
      showingConfirm: false,
      showingError: false,
      showingSuccessDelete: false,
      modalPlace: {},
      aux_modalPlace: {},
      modalAction: "",
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken")
        }
      },
      placeComments: [],
      showCommentsModal: false,
      categoryFilter: "-1",
      placeCategories: [],
      formOrder: "upward",
      polygon: polygon,
      srcUrl: 'apidev',
      zoom: 14,
      center: [19.412257, -99.200871],
      showMarker: false,
      geoStyle: {
        color: "#cb2833",
        fill: false
      }
    };
  },
  components: {
    LMap,
    LMarker,
    LGeoJson,
    PlaceModal,
    AlertDialog,
    PlaceCommentsModal
  },
  created() {
    let that = this;
/*     this.$socket.$subscribe("updateCategoryPlaceToMonitor", () => {
      that.fetchPlaces();
      that.fetchPlaceCategories();
    }); */
  },
  mounted() {
    this.fetchPlaces();
    this.fetchPlaceCategories();
  },
  methods: {
    onMapReady: function() {
      this.$nextTick(() => {
        const map = this.$refs.map.mapObject;
        esri.basemapLayer("Topographic").addTo(map);
      });
    },
    fetchPlaces() {
      this.axios
        .get("apidev/api/places", this.config)
        .then(response => {
          this.places = response.data;

          if (
            Object.keys(this.currentPlace).length === 0 &&
            this.currentPlace.constructor === Object
          ) {
            this.currentPlace = this.filteredPlaces[0];
          }
          this.center = [this.currentPlace.lat, this.currentPlace.lng];
          this.showMarker = true;
          this.fetchPlaceComments(this.currentPlace.id);
        })
        .catch(error => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.showingError = false;
        });
    },
    removeLineBreaks(description) {
      if (description === undefined || description === null) {
        return "";
      } else {
        return description.replace(/(?:\\r\\n)/g, "<br />");
      }
    },
    selectPlace(place) {
      this.currentPlace = place;
      this.modalPlace = {};
      this.center = [place.lat, place.lng];
      this.fetchPlaceComments(place.id);
    },
    closeModal(type) {
      if (type === "dismiss") {
        this.showPlaceModal = false;
      } else {
        this.fetchPlaces();
        this.search = "";
        this.showPlaceModal = false;
        this.showingSuccess = true;
      }
    },
    updateData(){
     // console.log("update data")
      if(this.modalPlace)
        this.currentPlace = this.modalPlace;
      //if(this.modalPlace.descripcion)
      //  this.currentPlace.descripcion = this.modalPlace.descripcion;
    },
    deletePlace() {
      this.axios
        .delete(
          "apidev/api/places/" + this.currentPlace.id,
          this.config
        )
        .then(response => {
          return this.axios.post(
            "apidev/api/binnacles/monitor/save/",
            {
              module: "Lugares de interes",
              action: "Elminación de un lugar de interes",
              observation: this.currentPlace.nombre,
              email: localStorage.getItem("email")
            },
            this.config
          );
        })
        .then(response => {
          this.currentPlace = {};
          this.fetchPlaces();
          this.search = "";
          this.showingConfirm = false;
          this.showingSuccessDelete = true;
        })
        .catch(error => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.showingError = false;
        });
    },
    openAddModal() {
      // this.modalPlace = {'working_hours': {
      this.modalPlace = {
        working: {
          monday: ["00:00", "00:00"],
          tuesday: ["00:00", "00:00"],
          wednesday: ["00:00", "00:00"],
          thursday: ["00:00", "00:00"],
          friday: ["00:00", "00:00"],
          saturday: ["00:00", "00:00"],
          sunday: ["00:00", "00:00"],
          enable: {
            monday: false,
            tuesday: false,
            wednesday: false,
            thursday: false,
            friday: false,
            saturday: false,
            sunday: false
          }
        }
      };
      this.modalAction = "add";
      this.showPlaceModal = true;
    },
    openEditModal() {
      this.modalPlace = Object.assign({}, this.currentPlace);
      this.aux_modalPlace = Object.assign({}, this.currentPlace);
      this.modalAction = "edit";
      this.showPlaceModal = true;
    },
    fetchPlaceComments(placeId) {
      this.axios
        .get("apidev/api/comments_places/" + placeId, this.config)
        .then(response => {
          this.placeComments = response.data;
        })
        .catch(error => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.showingError = false;
        });
    },
    closeCommentsModal() {
      this.showCommentsModal = false;
    },
    updateComments() {
      this.fetchPlaceComments(this.currentPlace.id);
    },
    fetchPlaceCategories() {
      this.axios
        .get("apidev/api/places/category", this.config)
        .then(response => {
          this.placeCategories = response.data;
        });
    },
    changeFormOrder() {
      if (this.formOrder === "upward") {
        this.formOrder = "downward";
      } else {
        this.formOrder = "upward";
      }
    }
  },
  computed: {
    filteredPlaces() {
      return this.places
        .filter(place => {
          return (
            (place.nombre.toLowerCase().includes(this.search.toLowerCase()) ||
              place.nombre_categoria
                .toLowerCase()
                .includes(this.search.toLowerCase())) &&
            (this.categoryFilter === "-1" ||
              place.categoria_id === this.categoryFilter.toString())
          );
        })
        .sort((a, b) => {
          if (this.formOrder === "upward") {
            if (a.nombre.toLowerCase() < b.nombre.toLowerCase()) {
              return -1;
            }
            if (a.nombre.toLowerCase() > b.nombre.toLowerCase()) {
              return 1;
            }
            return 0;
          } else {
            if (a.nombre.toLowerCase() > b.nombre.toLowerCase()) {
              return -1;
            }
            if (a.nombre.toLowerCase() < b.nombre.toLowerCase()) {
              return 1;
            }
            return 0;
          }
        });
    },
    workingHours() {
      let days = [
        {
          label: "Lunes",
          open: "",
          close: ""
        },
        {
          label: "Martes",
          open: "",
          close: ""
        },
        {
          label: "Miércoles",
          open: "",
          close: ""
        },
        {
          label: "Jueves",
          open: "",
          close: ""
        },
        {
          label: "Viernes",
          open: "",
          close: ""
        },
        {
          label: "Sábado",
          open: "",
          close: ""
        },
        {
          label: "Domingo",
          open: "",
          close: ""
        }
      ];

      for (let key in this.currentPlace.working) {
        switch (key) {
          case "monday":
            days[0].open = this.currentPlace.working[key][0];
            days[0].close = this.currentPlace.working[key][1];
            break;
          case "tuesday":
            days[1].open = this.currentPlace.working[key][0];
            days[1].close = this.currentPlace.working[key][1];
            break;
          case "wednesday":
            days[2].open = this.currentPlace.working[key][0];
            days[2].close = this.currentPlace.working[key][1];
            break;
          case "thursday":
            days[3].open = this.currentPlace.working[key][0];
            days[3].close = this.currentPlace.working[key][1];
            break;
          case "friday":
            days[4].open = this.currentPlace.working[key][0];
            days[4].close = this.currentPlace.working[key][1];
            break;
          case "saturday":
            days[5].open = this.currentPlace.working[key][0];
            days[5].close = this.currentPlace.working[key][1];
            break;
          case "sunday":
            days[6].open = this.currentPlace.working[key][0];
            days[6].close = this.currentPlace.working[key][1];
            break;
        }
      }

      return days;
    }
  }
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>